import OrgService from "@/services/OrgService.js";
import AppService from "@/services/AppService.js";

import JWT from "jsonwebtoken";
const namespaced = true;
const state = {
  SessionId: "",
  Session: true,
  admin: 0,
  org_details: {},
  user_name: "",
  app_urls: {},
  token: {},
  fiscal_year: [],
  code: "",
};
const mutations = {
  LIST_SESSION(state, data) {
    window.meta = data;
    state.token = JWT.sign(data.org_details.organization, process.env.VUE_APP_ENC_KEY);
    state.SessionId = data.data;
    state.admin = data.admin;
    state.org_details = data.org_details;
    state.app_urls = data.app_urls;
    state.user_name = data.user_name;
    state.fiscal_year = data.fiscal_year;
  },
  SESSION_STATUS(state, Session) {
    state.Session = Session;
  },
  STATUS_CODE(state, code) {
    state.code = code;
  },
};
const actions = {
  switchSession({ commit }, data) {
    return new Promise((resolve, reject) => {
      OrgService.app
        .getSwitchOrg(data)
        .then((response) => {
          if (response.status == 200) {
            window.location.reload();
          } else {
            window.location.href = process.env.VUE_APP_LOGOUT_URL;
          }
          commit("STATUS_CODE", response.status);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchSession({ commit }, admin) {
    return new Promise((resolve, reject) => {
      OrgService.app
        .getSessionId(admin)
        .then((response) => {
          const { data, org_details, app_urls } = response.data;
          if (response.status == 200) {
            commit("LIST_SESSION", response.data);
          } else if (response.status == 203) {
            window.location.href = process.env.VUE_APP_LOGOUT_URL;
          } else {
            window.location.href =
              process.env.VUE_APP_ORG_LOGOUT_URL +
              "?url=" +
              window.location.protocol +
              "//" +
              window.location.hostname;
          }
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setSession({ commit }, { session_id: session_id, admin: admin }) {
    return new Promise((resolve, reject) => {
      AppService.session
        .setSessionId(session_id, admin)
        .then((response) => {
          commit("STATUS_CODE", response.status);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
export default {
  namespaced,
  state,
  mutations,
  actions,
};
